var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',{staticClass:"score",style:(_vm.color)},[_vm._v(_vm._s(_vm.item['likelihoodAttack']))])])
}
var staticRenderFns = []

export { render, staticRenderFns }